import styled from 'styled-components/macro';

export const Divider = styled.div`
  border-bottom: 1px solid #000000;
  margin: 8px 0;
  width: 100%;
`;
